/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.invoice', ['popup']);
